export const MAX_SELECTION_LIMIT = 500;
export const BULK_CONFIRMATION_THRESHOLD = 50;
export const SELECTABLE_PROJECT_STATUSES = ['active', 'planning'];
